import { Box } from "@mui/material";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";

interface NursesWeekNominationBannerProps {
  onClick: () => void;
}

export function NursesWeekNominationBanner(props: NursesWeekNominationBannerProps) {
  const { onClick } = props;

  return (
    <Box>
      <PromotionBanner
        title="Nurses Week Nomination"
        subtitle="We are collecting real stories of excellent Nurses. Selected Nurses will be celebrated with gifts and recognition!"
        icon="star-filled"
        borderVariant="none"
        backgroundColor={(theme) => {
          const warmColor = theme.palette.shift?.urgent.background ?? theme.palette.info.light;
          const whiteColor = theme.palette.background.tertiary ?? theme.palette.common.white;
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- warm orange fading to white, evoking the Day shift palette. Uses a solid token as the start stop; shift.day.gradient is itself a gradient and nesting it here produces invalid CSS.
          return `linear-gradient(to right, ${warmColor}, ${whiteColor})`;
        }}
        ctaButtonText="Learn more"
        sx={{
          height: "100%",
          "& svg": {
            alignSelf: "flex-start",
          },
        }}
        onClick={onClick}
      />
    </Box>
  );
}
